import { BasketProviderController } from '@ori/basket-provider-lib';
import { ServiceUrlsProvider } from '@ori/configuration-manager';

import type { ClientAppConfig } from './types';

export const App = (configuration: ClientAppConfig) => {
  const { globalApiUrl, identityUrl, staticApiUrl } = configuration;

  return (
    <ServiceUrlsProvider
      serviceUrls={{
        globalApiUrl,
        identityUrl,
        staticApiUrl,
      }}
    >
      <BasketProviderController {...configuration} />
    </ServiceUrlsProvider>
  );
};
